export const ACTIVITIES_TITLE = 'Activities'
